import React, { useState, useEffect } from "react";
import ReactDOM from "react-dom";
import styles from "./ImageViewer.module.css";
import FileService from "../../Services/fileService";
import LoadingSpinner from "../../LayoutComponents/LoadingSpinner";

const ImageViewer = ({ id, onClose }) => {
  const [imageUrl, setImageUrl] = useState();
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const fetchImageUrl = async () => {
      setIsLoading(true);
      const url = await FileService.getFile(id);
      setImageUrl(url);
    };

    fetchImageUrl();
  }, [id]);

  const handleImageLoaded = () => {
    setIsLoading(false);
  };

  const handleCloseClick = (event) => {
    event.stopPropagation();
  };

  const handleOverlayClick = () => {
    onClose();
  };

  return ReactDOM.createPortal(
    <div className={styles.modalOverlay} onClick={handleOverlayClick}>
      <button className={styles.closeButton} onClick={onClose}>
        &times;
      </button>
      <div className={styles.modalContent} onClick={handleCloseClick}>
        {isLoading && (
          <div
            style={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              backgroundColor: "rgba(255,255,255,0.8)",
              padding: "20px",
              borderRadius: "30px",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              zIndex: 10,
            }}
          >
            <LoadingSpinner />
          </div>
        )}
        <img src={imageUrl} alt="full" className={styles.modalImage} onLoad={handleImageLoaded} />
      </div>
    </div>,
    document.body
  );
};

export default ImageViewer;
